import React from 'react';

interface HomeSectionShellProps {
  id?: string;
  title: string;
  subtitle?: React.ReactNode;
  variant?: 'default' | 'muted' | 'accent';
  children: React.ReactNode;
}

export const HomeSectionShell: React.FC<HomeSectionShellProps> = ({
  id,
  title,
  subtitle,
  variant = 'default',
  children,
}) => (
  <section
    id={id}
    className={`home-section home-section--${variant}`}
    aria-labelledby={id ? `${id}-heading` : undefined}
  >
    <div className="home-section__container">
      <header className="home-section__header">
        <h2 id={id ? `${id}-heading` : undefined} className="home-section__title">
          {title}
        </h2>
        {subtitle && <p className="home-section__subtitle">{subtitle}</p>}
      </header>
      {children}
    </div>
  </section>
);
